import { useEffect, useState } from "react";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { EVENTSPAGE, HOMEPAGE } from "../../constants/RoutingPath";
import "./style.css";

const BreadCrumb = ({ eventName, ticketSport }) => {
  const [searchParams] = useSearchParams();
  const [breadcrumb, setBreadcrumb] = useState([]);
  const sport_Type = ticketSport ? ticketSport : searchParams.get("sport_type");
  const navigate = useNavigate();

  useEffect(() => {
    const getBreadCrumb = async () => {
      if (sport_Type) {
        let modifySportType =
          sport_Type === "soccer"
            ? "football"
            : sport_Type === "formula1"
            ? "motorsport"
            : sport_Type;
        const breadcrumbs = [
          { pathname: "Home", path: HOMEPAGE },
          {
            pathname: `> ${modifySportType}`,
            param: {
              sport_type: modifySportType,
            },
            path: EVENTSPAGE,
          },
        ];
        if (eventName) {
          breadcrumbs.push({
            pathname: `> ${eventName}`,
            path: "",
          });
        }
        setBreadcrumb(breadcrumbs);
      }
    };
    getBreadCrumb();
  }, [searchParams, eventName]);

  return (
    <div className="breadcrumb" style={{ display: "flex" }}>
      {breadcrumb?.map((match, index) => (
        <h1
          key={index}
          onClick={() => {
            navigate({
              pathname: match.path,
              search: createSearchParams(match.param).toString(),
            });
          }}
          style={{
            textTransform: "capitalize",
            pointerEvents: index === breadcrumb.length - 1 ? "none" : "default",
            color:
              (breadcrumb.length === 2) & (index === 1)
                ? "var(--yellow-short)"
                : "",
          }}
        >
          {match.pathname}
        </h1>
      ))}
    </div>
  );
};

export default BreadCrumb;
